"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _ModalBtns = require("./ModalBtns.styles");

var ModalBtns = function ModalBtns(_ref) {
  var saveBtnText = _ref.saveBtnText,
      tertiaryBtnText = _ref.tertiaryBtnText,
      warningBtnText = _ref.warningBtnText,
      onSave = _ref.onSave,
      onClickTertiaryBtn = _ref.onClickTertiaryBtn,
      onClickWarningBtn = _ref.onClickWarningBtn,
      saveBtnDisabled = _ref.saveBtnDisabled,
      warningBtnDisabled = _ref.warningBtnDisabled,
      tertiaryBtnDisabled = _ref.tertiaryBtnDisabled,
      className = _ref.className,
      saveBtnHtmlType = _ref.saveBtnHtmlType,
      warningBtnHtmlType = _ref.warningBtnHtmlType,
      tertiaryBtnHtmlType = _ref.tertiaryBtnHtmlType,
      saveBtnForm = _ref.saveBtnForm,
      warningBtnForm = _ref.warningBtnForm,
      tertiaryBtnForm = _ref.tertiaryBtnForm,
      saveBtnAs = _ref.saveBtnAs,
      warningBtnAs = _ref.warningBtnAs,
      tertiaryBtnAs = _ref.tertiaryBtnAs,
      saveBtnHref = _ref.saveBtnHref,
      warningBtnHref = _ref.warningBtnHref,
      tertiaryBtnHref = _ref.tertiaryBtnHref,
      saveBtnTarget = _ref.saveBtnTarget,
      warningBtnTarget = _ref.warningBtnTarget,
      tertiaryBtnTarget = _ref.tertiaryBtnTarget,
      saveBtnTestId = _ref.saveBtnTestId,
      warningBtnTestId = _ref.warningBtnTestId,
      tertiaryBtnTestId = _ref.tertiaryBtnTestId,
      saveButtonType = _ref.saveButtonType,
      warningButtonType = _ref.warningButtonType,
      tertiaryButtonType = _ref.tertiaryButtonType;
  return (0, _jsxRuntime.jsxs)("div", {
    css: _ModalBtns.styles.base,
    className: className,
    children: [saveBtnText && (0, _jsxRuntime.jsx)(_Button["default"], {
      type: saveButtonType,
      onClick: onSave,
      disabled: saveBtnDisabled,
      htmlType: saveBtnHtmlType,
      form: saveBtnForm,
      as: saveBtnAs,
      href: saveBtnHref,
      target: saveBtnTarget,
      "data-test-id": saveBtnTestId,
      children: saveBtnText
    }), warningBtnText && (0, _jsxRuntime.jsx)(_Button["default"], {
      type: warningButtonType,
      onClick: onClickWarningBtn,
      disabled: warningBtnDisabled,
      htmlType: warningBtnHtmlType,
      form: warningBtnForm,
      as: warningBtnAs,
      href: warningBtnHref,
      target: warningBtnTarget,
      "data-test-id": warningBtnTestId,
      children: warningBtnText
    }), tertiaryBtnText && (0, _jsxRuntime.jsx)(_Button["default"], {
      type: tertiaryButtonType,
      onClick: onClickTertiaryBtn,
      htmlType: tertiaryBtnHtmlType,
      form: tertiaryBtnForm,
      disabled: tertiaryBtnDisabled,
      as: tertiaryBtnAs,
      href: tertiaryBtnHref,
      target: tertiaryBtnTarget,
      "data-test-id": tertiaryBtnTestId,
      children: tertiaryBtnText
    })]
  });
};

ModalBtns.propTypes = {
  className: _propTypes.string,

  /**
   * Save button
   */
  saveBtnText: _propTypes.node,
  onSave: _propTypes.func,
  saveBtnDisabled: _propTypes.bool,

  /**
   * Tertiary button
   */
  tertiaryBtnText: _propTypes.node,
  onClickTertiaryBtn: _propTypes.func,

  /**
   * Warning button
   */
  warningBtnText: _propTypes.node,
  onClickWarningBtn: _propTypes.func,
  warningBtnDisabled: _propTypes.bool,
  tertiaryBtnDisabled: _propTypes.bool,
  saveBtnHtmlType: (0, _propTypes.oneOf)(['button', 'submit', 'reset']),
  warningBtnHtmlType: (0, _propTypes.oneOf)(['button', 'submit', 'reset']),
  tertiaryBtnHtmlType: (0, _propTypes.oneOf)(['button', 'submit', 'reset']),
  saveBtnForm: _propTypes.string,
  warningBtnForm: _propTypes.string,
  tertiaryBtnForm: _propTypes.string,
  saveBtnAs: _propTypes.string,
  warningBtnAs: _propTypes.string,
  tertiaryBtnAs: _propTypes.string,
  saveBtnHref: _propTypes.string,
  warningBtnHref: _propTypes.string,
  tertiaryBtnHref: _propTypes.string,
  saveBtnTarget: _propTypes.string,
  warningBtnTarget: _propTypes.string,
  tertiaryBtnTarget: _propTypes.string,
  saveBtnTestId: _propTypes.string,
  warningBtnTestId: _propTypes.string,
  tertiaryBtnTestId: _propTypes.string,
  saveButtonType: _propTypes.string,
  warningButtonType: _propTypes.string,
  tertiaryButtonType: _propTypes.string
};
ModalBtns.defaultProps = {
  className: undefined,
  saveBtnText: undefined,
  onSave: undefined,
  saveBtnDisabled: false,
  tertiaryBtnText: undefined,
  onClickTertiaryBtn: undefined,
  warningBtnText: undefined,
  onClickWarningBtn: undefined,
  warningBtnDisabled: false,
  tertiaryBtnDisabled: false,
  saveBtnHtmlType: undefined,
  warningBtnHtmlType: undefined,
  tertiaryBtnHtmlType: undefined,
  saveBtnForm: undefined,
  warningBtnForm: undefined,
  tertiaryBtnForm: undefined,
  saveBtnAs: undefined,
  warningBtnAs: undefined,
  tertiaryBtnAs: undefined,
  saveBtnHref: undefined,
  warningBtnHref: undefined,
  tertiaryBtnHref: undefined,
  saveBtnTarget: undefined,
  warningBtnTarget: undefined,
  tertiaryBtnTarget: undefined,
  saveBtnTestId: undefined,
  warningBtnTestId: undefined,
  tertiaryBtnTestId: undefined,
  saveButtonType: 'primary',
  warningButtonType: 'warning',
  tertiaryButtonType: 'tertiary'
};
var _default = ModalBtns;
exports["default"] = _default;
//# sourceMappingURL=ModalBtns.js.map